import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ConnectWithUs from "./sections/ConnectWithUs";
import StartYourIntegration from "./sections/StartYourIntegration";
import SupportFaq from "./sections/SupportFaq";
import FooterArchive from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ConnectWithUs />
      <StartYourIntegration />
      <SupportFaq />
      <FooterArchive />
    </div>;
}